module.exports = __webpack_public_path__ + "static/media/icon-pill-paddle-ball.ea6cac18.svg";